module.exports = __webpack_public_path__ + "img/portal.24f08dd.png";